import AppLoading from 'core/containers/App/AppLoading'
import { Container } from './styles'

const LoadingModule = () => {
  return (
    <Container>
      <AppLoading message="Carregando módulo" />
    </Container>
  )
}

export default LoadingModule
